import { useState, useEffect } from 'react';
import AcquirerService from "../../../../services/acquirer_service";
import MembershipService from "../../../../services/membership_service";
import CashierShiftService from "../../../../services/cashier_shift_service";
import { toast } from 'react-toastify';

/**
 * Hook dedicado a gerenciar o carregamento de dados do PDV 
 * e a abertura/verificação de Caixa (Shift).
 */
export const useSalesInitialization = ({ isReady, idTenant, user }) => {
    const [acquirers, setAcquirers] = useState([]);
    const [memberships, setMemberships] = useState([]);
    const [currentShift, setCurrentShift] = useState(null);
    const [isLoadingData, setIsLoadingData] = useState(true);
    const [isCashierModalOpen, setIsCashierModalOpen] = useState(false);
    const [isProcessingShift, setIsProcessingShift] = useState(false);

    useEffect(() => {
        if (!isReady) return;

        const loadData = async () => {
            try {
                setIsLoadingData(true);
                const [acqs, conts, shift] = await Promise.all([
                    AcquirerService.getAcquirers(idTenant),
                    MembershipService.getMemberships(idTenant),
                    CashierShiftService.getMyOpenShift(idTenant, user?.uid)
                ]);

                setAcquirers(acqs.filter(a => a.status === "active"));
                setMemberships(conts);
                setCurrentShift(shift);

                if (!shift) {
                    setIsCashierModalOpen(true);
                }
            } catch (error) {
                console.error("Erro ao carregar dados do PDV:", error);
                toast.error("Erro ao carregar configurações de venda.");
            } finally {
                setIsLoadingData(false);
            }
        };

        loadData();
    }, [isReady, idTenant, user?.uid]);

    const handleOpenShift = async ({ idBankAccount, openingBalance }) => {
        try {
            setIsProcessingShift(true);
            const shift = await CashierShiftService.openShift(idTenant, {
                idBankAccount,
                operatorId: user?.uid,
                operatorName: user?.displayName || user?.fullName || user?.name || user?.email || "",
                openingBalance,
                actingUser: user,
                canManageAll: false
            });
            setCurrentShift(shift);
            setIsCashierModalOpen(false);
            toast.success("Caixa aberto com sucesso! Você já pode realizar vendas.");
        } catch (err) {
            console.error("Erro ao abrir caixa:", err);
            toast.error(err.message || "Não foi possível abrir o caixa.");
        } finally {
            setIsProcessingShift(false);
        }
    };

    const toggleCashierModal = () => setIsCashierModalOpen(!isCashierModalOpen);

    return {
        acquirers,
        memberships,
        currentShift,
        isLoadingData,
        isCashierModalOpen,
        isProcessingShift,
        handleOpenShift,
        toggleCashierModal
    };
};
